// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3ve1P","disabled":"FileBtn_disabled__29-wU","warn":"FileBtn_warn__3b4lh","fade":"FileBtn_fade__2B8Jj"};